import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "advance-transaction panel bg-white" }
const _hoisted_2 = { class: "row justify-between no-space" }
const _hoisted_3 = { class: "transaction-title margin-0" }
const _hoisted_4 = {
  key: 0,
  class: "advance-type cancelled"
}
const _hoisted_5 = { class: "issue-date text-body-light" }
const _hoisted_6 = { class: "text-right" }
const _hoisted_7 = { class: "total-text text-body-light" }
const _hoisted_8 = { class: "total-amount" }
const _hoisted_9 = { class: "bar" }
const _hoisted_10 = { class: "row justify-between no-space" }
const _hoisted_11 = { class: "recouped text-secondary" }
const _hoisted_12 = { class: "remaining text-right text-body-light" }

import { computed } from 'vue'
import { useGettext } from 'vue3-gettext'
import { formatAmount } from '@/helpers/formatAmount'
import { formatDate } from '@/helpers/formatDate'
import { AdvanceType } from '@/constants'


export default /*@__PURE__*/_defineComponent({
  __name: 'GroupedAdvanceTransaction',
  props: {
    advanceNumber: {},
    advanceType: {},
    transaction: {}
  },
  setup(__props: any) {

const { $gettext } = useGettext()

const props = __props

const transactionTitle = computed(() => {
  let label: string
  switch (props.advanceType) {
    case AdvanceType.user:
      label = $gettext('Account Advance')
      break
    case AdvanceType.asset:
      label = $gettext('Track Advance')
      break
    default:
      label = $gettext('Release Advance')
  }

  return `${label} #${props.advanceNumber}`
})

const remainingTotal = computed(() => parseFloat(props.transaction.amount) - parseFloat(props.transaction.bundledAmount))
const percentageRecouped = computed(() => (
  remainingTotal.value === 0
    ? '100'
    : ((parseFloat(props.transaction.bundledAmount) / parseFloat(props.transaction.amount)) * 100).toFixed(2)
))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("h4", _hoisted_3, [
          _createTextVNode(_toDisplayString(transactionTitle.value) + " ", 1),
          (__props.transaction.endsAt)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref($gettext)('Cancelled')), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("small", _hoisted_5, _toDisplayString(_unref($gettext)('Issued')) + " " + _toDisplayString(_unref(formatDate)(__props.transaction.createdAt)), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("span", _hoisted_7, _toDisplayString(_unref($gettext)('Advance')), 1),
        _createElementVNode("strong", _hoisted_8, _toDisplayString(_unref(formatAmount)(__props.transaction.amount, false)), 1)
      ])
    ]),
    _createElementVNode("figure", _hoisted_9, [
      _createElementVNode("div", {
        class: "bar-done",
        style: _normalizeStyle(`width: ${percentageRecouped.value}%;`)
      }, null, 4)
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("small", null, [
        _createElementVNode("strong", _hoisted_11, _toDisplayString(_unref(formatAmount)(__props.transaction.bundledAmount, false)) + " " + _toDisplayString(_unref($gettext)('recouped')) + " " + _toDisplayString(`(${percentageRecouped.value}%)`), 1)
      ]),
      _createElementVNode("small", _hoisted_12, _toDisplayString(_unref(formatAmount)(remainingTotal.value, false)) + " " + _toDisplayString(_unref($gettext)('remaining')), 1)
    ])
  ]))
}
}

})